<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'HeaderNotice',
})
</script>
<template>
  <!--placement="bottomRight"
    :autoAdjustOverflow="false"
  :arrowPointAtCenter="true"-->
  <a-popover v-model:open="visible" trigger="click" :placement="isMobile ? 'bottom' : 'bottomRight'"
    overlayClassName="header-notice-wrapper" :getPopupContainer="getPopupContainer"
    :overlayStyle="{ width: isMobile ? '250px' : '300px', top: '50px' }">
    <template #content>
      <a-spin :spinning="loading">
        <a-tabs>
          <a-tab-pane tab="消息" key="1">
            <a-list>
              <a-list-item v-for="(item,i) in msgList" :key="i" >
                <a-list-item-meta  :description="item.content">
                  <template #title>
                    <RouterLink >{{ ' ['+item.retime+']'+ item.title }}</RouterLink>
                  </template>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-tab-pane>
          <a-tab-pane tab="待办" key="2">
            <a-list>
              <a-list-item v-for="(item,i) in todoList" :key="i">
                <a-list-item-meta  :description="item.content">
                  <template #title>
                    <RouterLink >{{ ' ['+item.retime+']'+ item.title }}</RouterLink>
                  </template>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </template>
    <span @click="fetchNotice" class="header-notice" ref="noticeRef" style="padding: 0 18px">
      <a-badge :count="msgCount">
        <BellOutlined style="font-size: 16px; padding: 4px" />
      </a-badge>
    </span>
  </a-popover>
</template>

<script lang="ts" setup name="HeaderNotice">
import { ref,onMounted,reactive } from 'vue'
import { BellOutlined } from '@ant-design/icons-vue'
import { isMobile } from '@/utils/device'
import api from '@/utils/http/service'

const loading = ref<boolean>(false)
const visible = ref<boolean>(false)
const noticeRef = ref(null)
const msgCount=ref<number>(0)
let msgList=reactive<Array<any>>([])
let todoList=reactive<Array<any>>([])
onMounted(()=>{
  loading.value=true
  api.report.todo().then(res => {
    loading.value=false
        if (res.state == 1) {
          msgList = res.data.msg
          todoList = res.data.todo
          msgCount.value= msgList.length + todoList.length
        }
      })
})

const fetchNotice = () => {
  if (!visible.value) {
    loading.value = true
    setTimeout(() => {
      loading.value = false
    }, 300)
  } else {
    loading.value = false
  }
  // visible.value = !visible.value;
}

const getPopupContainer = () => {
  return noticeRef.value!.parentElement
}
</script>

<style lang="css">
.header-notice-wrapper {
  top: 50px !important;
}
</style>
<style lang="less" scoped>
.header-notice {
  display: inline-block;
  transition: all 0.3s;

  span {
    // vertical-align: initial;
  }
}
</style>
